import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const state = {
    order: null,
    paymentType: 'credit_card'
};

const getters = {
    GET_CART_ORDER: state => state.order,
    GET_PAYMENT_TYPE: state => state.paymentType,
};

const mutations = {
    SET_CART_ORDER(state, data) {
        state.order = data;
    },
    SET_PAYMENT_TYPE(state, data) {
        state.paymentType = data;
    }
};

const actions = {
    async ACT_CART_ORDER ({commit}, data) {
        await commit('SET_CART_ORDER', data);
    }
};

const store = new Vuex.Store({
    state, getters, actions, mutations
});

export default store
